import { render, staticRenderFns } from "./couponlist.vue?vue&type=template&id=63d7131f&scoped=true&"
import script from "./couponlist.vue?vue&type=script&lang=js&"
export * from "./couponlist.vue?vue&type=script&lang=js&"
import style0 from "./couponlist.vue?vue&type=style&index=0&id=63d7131f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d7131f",
  null
  
)

export default component.exports